import serviceDocument from "../../services/patient/DocumentService";
import PatientService from "../../services/patient/PatientService";
import i18n from "../../i18n/index";
import { StorageService } from "../../services/StorageService";
import serviceCalendar from "../../services/calendarAppointment/serviceCalendar";
import dayjs from "dayjs";
import AppointmentService from "../../services/appointment/ServiceAppointment";
import appointmentList from "./appointmentList/appointmentList.vue";
import locationService from '../../services/location/LocationService.js'
import deliveryPointService from '../../services/delivery-point/DeliveryPointService'
import parametersService from '../../services/parameters/ParametersService'
import serviceOrder from "../../services/orders/OrderService.js";

export default {
    components: {
        appointmentList
    },
    data: () => ({
        showGrid: true,
        panel: [],
        menuDelivery: false,
        providers: [],
        observation: "",
        patientListData: [],
        disableSaveButton: false,
        menu: false,

        rules: { required: value => !!value || "El campo es requerido" },
        states: [],
        cities: [],
        documentTypeItems: [],
        orderPatient: [],
        patient: {
            id: "",
            type: "",
            document: "",
            fullname: "",
            address: "",
            cellPhoneNumber: "",
            phoneNumber: ""
        },
        dialog: false,
        idOrderAppointment: "",
        buttonDisabled: false,
        state: '',
        city: '',
        deliveryPoint: '',
        address: '',
        appointmentDate: '',
        minDate: '',
        scheduleRanges: [],
        scheduleRange: '',
        status: '',
        newAppointment: true,
        userIsAdmin: false,
        id: '',
        cancelReasons: [],
        cancelReasonToShow: '',
        selectedDP: {
            name: '',
            address: ''
        },
        selectedSR: {
            range: ''
        },
        loadingSave: false,
        loadingEdit: false,
        headers: [
            {
              sortable: false,
              text: i18n.t("headers.order-detail-number"),
              value: "orderCode",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.plu"),
              value: "plu",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.description"),
              value: "description",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.qty"),
              value: "count",
              align: "left",
            },
            {
              sortable: false,
              text: i18n.t("headers.ssfee"),
              value: "scaleFee",
              align: "left",
            }
        ],
        medicines: [],
        userWithAuthorizations: false,
        noteText: ''
    }),
    created () {},

    async mounted () {
        this.getDocumentTypes();
        this.getStates();
        await this.validateUser();
        await this.getNoteText();
        this.getCancelReasons()
    },

    methods: {
        async validateUser () {
            try {
                const parameter = (await parametersService.getParameterById(4)).data;
                const user = StorageService.getUserData();
                if (parseInt(parameter.value) === user.rol) {
                    this.userIsAdmin = true
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getNoteText () {
            try {
                this.noteText= ((await parametersService.getParameterById(6)).data).value;
            } catch (error) {
                console.log(error)
            }
        },
        async getCancelReasons () {
            try {
                const response = await AppointmentService.getCancelReasons()
                this.cancelReasons = response.data
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Error consultando los motivos de cancelación"
                });
            }
        },
        disableButton() {
            if (
                this.patient.type == "" ||
                this.patient.document == "" ||
                this.patient.fullname == "" ||
                this.state == "" ||
                this.city == "" ||
                this.appointmentDate == "" ||
                this.scheduleRange == ""
            ) {
                return (this.buttonDisabled = true);
            }
        },
        async saveAppointment() {
            try {
                this.loadingSave = true
                if (this.patient.type === '' || this.patient.type === undefined || this.patient.type === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el tipo de documento del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.document === '' || this.patient.document === undefined || this.patient.document === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de documento del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.fullname === '' || this.patient.fullname === undefined || this.patient.fullname === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el nombre del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.cellPhoneNumber === '' || this.patient.cellPhoneNumber === undefined || this.patient.cellPhoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número celular del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.phoneNumber === '' || this.patient.phoneNumber === undefined || this.patient.phoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de teléfono del paciente'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.cellPhoneNumber[0] !== '3' || this.patient.cellPhoneNumber.length !== 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número celular tiene un formato erróneo'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.patient.phoneNumber.length < 7 || this.patient.phoneNumber.length > 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número de teléfono tiene un formato erróneo'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.deliveryPoint === '' || this.deliveryPoint === undefined || this.deliveryPoint === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un punto de entrega'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.appointmentDate === '' || this.appointmentDate === undefined || this.appointmentDate === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar una fecha de cita'
                    });
                    this.loadingSave = false
                    return;
                }
                if (this.scheduleRange === '' || this.scheduleRange === undefined || this.scheduleRange === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un horario de atención'
                    });
                    this.loadingSave = false
                    return;
                }
                let formData = {
                    patient: this.patient,
                    city: this.city,
                    date: this.appointmentDate,
                    scheduleRange: this.scheduleRange,
                    deliveryPoint: this.deliveryPoint,
                    observation: this.observation,
                    userIsAdmin: this.userIsAdmin,
                    user: StorageService.getUserData().id,
                    medicines: this.medicines
                };
                this.disableSaveButton = true;

                const response = await AppointmentService.saveAppointment(
                    formData
                );
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita agendada correctamente"
                });
                this.loadingSave = false
                this.closeAppointment(true);
            } catch (error) {
                if (error.message === 'Full capacity') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El horario seleccionado ya no se encuentra disponible"
                    });
                    this.loadingSave = false
                } else {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Ha ocurrido un error al agendar el pedido"
                    });
                    this.loadingSave = false
                }
            } 
        },
        async editAppointment() {
            try {
                this.loadingEdit = true
                if (this.patient.type === '' || this.patient.type === undefined || this.patient.type === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el tipo de documento del paciente'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.document === '' || this.patient.document === undefined || this.patient.document === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de documento del paciente'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.fullname === '' || this.patient.fullname === undefined || this.patient.fullname === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el nombre del paciente'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.cellPhoneNumber === '' || this.patient.cellPhoneNumber === undefined || this.patient.cellPhoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número celular del paciente'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.phoneNumber === '' || this.patient.phoneNumber === undefined || this.patient.phoneNumber === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe ingresar el número de teléfono del paciente'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.cellPhoneNumber[0] !== '3' || this.patient.cellPhoneNumber.length !== 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número celular tiene un formato erróneo'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.patient.phoneNumber.length < 7 || this.patient.phoneNumber.length > 10) {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'El número de teléfono tiene un formato erróneo'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.deliveryPoint === '' || this.deliveryPoint === undefined || this.deliveryPoint === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un punto de entrega'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.appointmentDate === '' || this.appointmentDate === undefined || this.appointmentDate === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar una fecha de cita'
                    });
                    this.loadingEdit = false
                    return;
                }
                if (this.scheduleRange === '' || this.scheduleRange === undefined || this.scheduleRange === '') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: 'Debe seleccionar un horario de atención'
                    });
                    this.loadingEdit = false
                    return;
                }
                let formData = {
                    id: this.id,
                    patient: this.patient,
                    city: this.city,
                    date: this.appointmentDate,
                    scheduleRange: this.scheduleRange,
                    deliveryPoint: this.deliveryPoint,
                    observation: this.observation,
                    userIsAdmin: this.userIsAdmin,
                    user: StorageService.getUserData().id
                };
                this.disableSaveButton = true;

                const response = await AppointmentService.editAppointment(
                    formData
                );
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita modificada correctamente"
                });
                this.loadingEdit = false
                this.closeAppointment(true);
            } catch (error) {
                if (error.message === 'Full capacity') {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "El horario seleccionado ya no se encuentra disponible"
                    });
                    this.loadingEdit = false
                } else {
                    this.$notify({
                        group: "app",
                        type: "error",
                        text: "Ha ocurrido un error al agendar el pedido"
                    });
                    this.loadingEdit = false
                }
            } 
        },
        closeAppointment(reloadAppointments) {
            this.patient = {
                id: "",
                type: "",
                document: "",
                fullname: "",
                cellPhoneNumber: "",
                phoneNumber: ""
            };
            this.medicines = []
            this.state = ''
            this.city = ''
            this.scheduleRange = ''
            this.address = ''
            this.status = ''
            if (reloadAppointments) {
                this.$refs.appointmentList.getAppointments();
            }
            this.newAppointment = true
            this.userIsAdmin = false
            this.id = ''
            this.selectedDP = {
                name: '',
                address: ''
            }
            this.selectedSR = {
                range: ''
            }
            this.showGrid = true
        },

        clearAppointment() {
            this.patient = {
                id: "",
                type: this.patient.type,
                document: this.patient.document,
                fullname: "",
                cellPhoneNumber: "",
                phoneNumber: ""
            };
            this.medicines = []
            this.state = ''
            this.city = ''
            this.scheduleRange = ''
            this.address = ''
            this.status = ''
            this.newAppointment = true
            this.id = ''
            this.selectedDP = {
                name: '',
                address: ''
            }
            this.selectedSR = {
                range: ''
            }
        },

        contains(arr, id) {
            return arr.some(e => e.id === id);
        },
        filterKeyCount(e) {
            const key = e.key;
            if (/[0-9]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        filterKey(e) {
            const key = e.key;
            if (/[0-9--]/.test(key)) {} else {
                return e.preventDefault();
            }
        },
        filterKeyletters(e) {
            const key = e.key;
            if (/[A-Za-z- ]/.test(key)) {} else {
                return e.preventDefault();
            }
        },

        showError(text) {
            this.$notify({
                group: "app",
                type: "error",
                text
            });
        },

        customFilter(item, queryText, itemText) {
            const textOne = item.description.toLowerCase();
            const textTwo = item.plu.toLowerCase();
            const searchText = queryText.toLowerCase();

            return (
                textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
            );
        },

        getDocumentTypes() {
            serviceDocument.getDocuments().then(response => {
                this.documentTypeItems = response.data;
            });
        },

        getMedicines(order) {
            let medicines = []
            for (let i = 0; i < order.orderDetails.length; i++) {
                const od = order.orderDetails[i];
                for (let j = 0; j < od.orderDetailMedicines.length; j++) {
                    const medicine = od.orderDetailMedicines[j];
                    medicines.push({
                        orderCode: od.code,
                        plu: medicine.pluCode,
                        description: medicine.description,
                        count: medicine.quantity,
                        scaleFee: od.slidingScaleFee
                    })
                }
            }
            return medicines
        },

        async searchPatient() {
            if (!this.patient.type) {
                this.showError(i18n.t("no-options-selected-for-document-type"));
                return;
            }

            if (!this.patient.document) {
                this.showError(i18n.t("no-patient-id"));
                return;
            }

            this.clearAppointment()

            try {
                let response = await serviceOrder.getAuthorizations(this.patient.type, this.patient.document)
                this.medicines = this.getMedicines(response.data)
                this.patient.fullname = response.data.orderPatients[0].idPatient.name
                this.userWithAuthorizations = true;
            } catch (error) {
                console.log(error)
                this.userWithAuthorizations = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "No se han encontrado autorizaciones para el paciente especificado."
                });
                return
            }

            try {
                let response = await PatientService.getByDocument(
                    this.patient.type,
                    this.patient.document
                )
                const data = response.data;
                this.patient.id = data.id;
                // this.patient.fullname = data.name;
                this.patient.address = data.address;
                this.patient.cellPhoneNumber = data.mobilePhone;
                this.patient.phoneNumber = data.phone;
            } catch (error) {
                // this.showError(i18n.t("patient-not-exist"));
            }
        },
        async getStates () {
            try {
                let response = await locationService.getStatesWithDeliveryPoint()
                this.states = response.data
                this.state = ''
                this.city = ''
            } catch (error) {
                this.$notify({
                group: "app",
                type: "error",
                text: 'Error consultando los departamentos'
                })
            }
        },
        async getCities () {
            try {
                const data = {
                    ids: [this.state]
                }
                let response = await locationService.getCitiesWithDeliveryPoint(data)
                this.cities = response.data
                this.city = ''
                this.deliveryPoint = ''
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error'
                })
            }
        },

        async getDeliveryPoints () {
            try {
                let response = await deliveryPointService.getByCity(this.city)
                this.deliveryPoints = response.data
                this.deliveryPoint = ''
                this.$forceUpdate()
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error'
                })
            }
        },
        async getAddressAndAllowedDates() {
            this.selectedDP = this.deliveryPoints.find(dp => dp.id == this.deliveryPoint);
            this.address = this.selectedDP.address ? this.selectedDP.address : "";

            try {
                let response = await serviceCalendar.getAllowedDates(this.deliveryPoint, this.userIsAdmin)
                this.enabledDays = response.data
                this.minDate = this.enabledDays[0].date
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error consultando calendario'
                })
            }            
        },
        getAllowedDates(testDate) {
            for (let i = 0; i < this.enabledDays.length; i++) {
                if (this.enabledDays[i].date == testDate) {
                    return testDate
                }
            }
        },
        async getScheduleRanges() {
            const selectedDate = this.enabledDays.find(date => date.date == this.appointmentDate)
            try {
                if (selectedDate) {
                    let response = await serviceCalendar.getScheduleRanges(selectedDate.id, this.userIsAdmin)
                    if (response.data.length === 0) {
                        this.$notify({
                            group: "app",
                            type: "warning",
                            text: 'No hay turnos disponibles para la fecha seleccionada'
                        })
                    } else {
                        this.scheduleRanges = response.data.map(sr => {
                            return {
                                capacity: sr.capacity,
                                consecutive: sr.consecutive,
                                enabled: sr.enabled,
                                id: sr.id,
                                maxCapacity: sr.maxCapacity,
                                range: dayjs(sr.range).format('hh:mm A')
                            }
                        })
                    }
                }
                this.scheduleRange = ''
            } catch (error) {
                console.log(error)
                this.$notify({
                    group: "app",
                    type: "error",
                    text: 'Error consultando los horarios para el dia seleccionado'
                })
            }
        },
        getSelectedScheduleRange () {
            this.selectedSR = this.scheduleRanges.find(sr => sr.id == this.scheduleRange);
        },
        async cancelApointment() {
            if (this.cancelReason === '') {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "No se ha seleccionado un motivo de cancelación"
                });
                return
            }
            try {
                await AppointmentService.cancelAppointment({ id: this.id, cancelReason: this.cancelReason, medicines: this.medicines })
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita cancelada con éxito."
                })
                this.dialog = false
                this.closeAppointment(true);
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Error al cancelar la cita"
                });
                this.dialog = false
            }
        },
        async attend() {
            try {
                await AppointmentService.attend({ id: this.id })
                this.$notify({
                    group: "app",
                    type: "success",
                    text: "Cita asistida"
                });
                this.closeAppointment(true);
            } catch (error) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Error al cambiar el estado de la cita"
                });
            }
        },

        async handleOrder(appointment) {
            this.newAppointment = false
            this.id = appointment.id
            this.showGrid = !this.showGrid
            const patient = appointment.patient

            this.medicines = []
            appointment.appointmentMedicines.forEach(medicine => {
                this.medicines.push({
                    orderCode: medicine.authorization,
                    plu: medicine.plu,
                    description: medicine.description,
                    count: medicine.quantity,
                    scaleFee: medicine.scaleFee
                })
            })

            this.userWithAuthorizations = true

            this.patient.id = patient.id
            this.patient.type = patient.idIdentificationType.id
            this.patient.document = patient.identification
            this.patient.fullname = patient.name
            this.patient.cellPhoneNumber = patient.mobilePhone
            this.patient.phoneNumber = patient.phone

            this.state = appointment.deliveryPoint.city.idState.id
            await this.getCities()
            this.city = appointment.deliveryPoint.city.id
            await this.getDeliveryPoints()
            this.deliveryPoint = appointment.deliveryPoint.id
            await this.getAddressAndAllowedDates()
            this.appointmentDate = appointment.date
            await this.getScheduleRanges()
            if (!this.contains(this.scheduleRanges, appointment.scheduleRangeAppointment.id)) {
                this.scheduleRanges.push({
                    id: appointment.scheduleRangeAppointment.id,
                    range: appointment.scheduleRangeAppointment.range
                })
            }
            this.scheduleRange = appointment.scheduleRangeAppointment.id
            this.getSelectedScheduleRange()
            this.status = appointment.status
            this.observation = appointment.observation
            this.cancelReasonToShow = appointment.cancelReason
        },
        validateNumberCellphone() {
            if (this.patient.cellPhoneNumber[0] == '' || this.patient.cellPhoneNumber[0] == undefined) {
              return
            }
            if (this.patient.cellPhoneNumber[0] != '3') {
              this.$notify({
                group: "app",
                type: "error",
                text: "El número celular debe empezar con el número 3."
              })
            }
            if (this.patient.cellPhoneNumber.length == 10) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.cellPhoneNumber.length; i++) {
                let numberInitial = this.patient.cellPhoneNumber[0]
      
                if (numberInitial == this.patient.cellPhoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                 group: "app",
                 type: "error",
                 text: "Número inválido."
                })
              }
            }
          },
          validateNumberphone() {
            if (this.patient.phoneNumber[0] == '' || this.patient.phoneNumber[0] == undefined) {
              return
            }
            if (this.patient.phoneNumber.length >= 7) {
              this.buttonDisabled = true;
              let count = 0;
              for (let i = 0; i < this.patient.phoneNumber.length; i++) {
                let numberInitial = this.patient.phoneNumber[0]
      
                if (numberInitial == this.patient.phoneNumber[i]) {
                  count += 1;
                }
              }
              if (count >= 7) {
                this.buttonDisabled = false;
                this.$notify({
                    group: "app",
                    type: "error",
                    text: "Número inválido."
                })
              }
            }
          }        
    },
    watch: {
        cellPhoneNumber() {
            this.validateNumberCellphone()
          },
        phoneNumber() {
            this.validateNumberphone()
          },
    },
    computed: {
        phoneNumber() {
            return this.patient.phoneNumber;
        },
        cellPhoneNumber(){
            return this.patient.cellPhoneNumber;
        },
        notes: {
            get() {
                return (
                    `Su cita queda programada para el día ${this.appointmentDate},` +
                    `en el horario ${this.selectedSR.range} ` +
                    `en el punto de entrega ${this.selectedDP.name}. ` +
                    `${this.noteText}`
                );
            },
            set(notes) {
                this.notes = notes;
            }
        }
    }
};